<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div
    id="kt_app_toolbar_container"
    class="app-container container-fluid d-flex flex-stack"
  >
    <!--begin::Page title-->
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
    >
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg
            width="36"
            height="38"
            viewBox="0 0 36 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_373_934)">
              <path
                d="M4.60489 6.04201H8.77521C9.1081 6.04201 9.38048 5.76959 9.38048 5.43673V1.26638C9.38048 1.02433 9.23522 0.800305 9.00522 0.709573C8.78127 0.612708 8.521 0.667162 8.34549 0.836657L4.18119 5.00701C4.00564 5.18249 3.95118 5.44279 4.04801 5.66674C4.13882 5.89675 4.36276 6.04201 4.60489 6.04201Z"
                fill="#265D91"
              />
              <path
                d="M12.2618 21.9129V18.9894C12.2618 17.9881 13.0763 17.1736 14.0776 17.1736H14.8236L14.2934 16.6434C13.9505 16.3017 13.7614 15.846 13.7614 15.3607C13.7614 14.8754 13.9505 14.4197 14.2946 14.0769L16.3634 12.008C16.6719 11.68 17.1472 11.4778 17.6431 11.4778C18.1301 11.4778 18.587 11.6664 18.9287 12.008L19.4589 12.5383V11.7923C19.4589 10.791 20.2734 9.97647 21.2747 9.97647H23.3385V1.26677C23.3385 0.933843 23.0722 0.661499 22.7332 0.661499H10.486C10.5522 0.851977 10.5914 1.05502 10.5914 1.26677V5.43691C10.5914 6.43821 9.77686 7.25273 8.77556 7.25273H4.60542C4.39378 7.25273 4.19081 7.21343 4 7.14648V25.6473C4 25.9802 4.27234 26.2526 4.60528 26.2526H13.9076C13.8127 26.0304 13.7614 25.7902 13.7614 25.5416C13.7614 25.0563 13.9505 24.6006 14.2946 24.2578L14.823 23.7287H14.0776C13.0763 23.7287 12.2618 22.9142 12.2618 21.9129ZM10.6599 21.5943H7.63357C7.29902 21.5943 7.0283 21.3236 7.0283 20.989C7.0283 20.6545 7.29902 20.3838 7.63357 20.3838H10.6599C10.9945 20.3838 11.2652 20.6545 11.2652 20.989C11.2652 21.3236 10.9945 21.5943 10.6599 21.5943ZM10.6599 17.9627H7.63357C7.29902 17.9627 7.0283 17.692 7.0283 17.3574C7.0283 17.0228 7.29902 16.7521 7.63357 16.7521H10.6599C10.9945 16.7521 11.2652 17.0228 11.2652 17.3574C11.2652 17.692 10.9945 17.9627 10.6599 17.9627ZM10.6599 14.331H7.63357C7.29902 14.331 7.0283 14.0603 7.0283 13.7257C7.0283 13.3912 7.29902 13.1205 7.63357 13.1205H10.6599C10.9945 13.1205 11.2652 13.3912 11.2652 13.7257C11.2652 14.0603 10.9945 14.331 10.6599 14.331ZM10.6599 10.6994H7.63357C7.29902 10.6994 7.0283 10.4287 7.0283 10.0941C7.0283 9.75954 7.29902 9.48882 7.63357 9.48882H10.6599C10.9945 9.48882 11.2652 9.75954 11.2652 10.0941C11.2652 10.4287 10.9945 10.6994 10.6599 10.6994Z"
                fill="#265D91"
              />
              <path
                d="M31.3948 18.384H29.0706C28.9617 18.0572 28.8285 17.7364 28.6772 17.4337L30.3175 15.7874C30.5596 15.5514 30.5596 15.17 30.3175 14.934L28.2535 12.8639C28.0174 12.6279 27.6361 12.6279 27.4 12.8639L25.7537 14.5103C25.445 14.3529 25.1303 14.2258 24.8034 14.1168V11.7926C24.8034 11.4537 24.531 11.1873 24.1982 11.1873H21.2747C20.9418 11.1873 20.6694 11.4537 20.6694 11.7926V14.1168C20.3426 14.2258 20.0278 14.3529 19.7191 14.5103L18.0728 12.8639C17.9578 12.7489 17.8064 12.6884 17.643 12.6884C17.4856 12.6884 17.3283 12.7489 17.2193 12.8639L15.1493 14.934C14.9132 15.17 14.9132 15.5514 15.1493 15.7874L16.7956 17.4337C16.6382 17.7364 16.5111 18.0572 16.4022 18.384H14.0779C13.739 18.384 13.4727 18.6564 13.4727 18.9893V21.9128C13.4727 22.2457 13.739 22.5181 14.0779 22.5181H16.4022C16.5111 22.8449 16.6382 23.1597 16.7956 23.4684L15.1493 25.1147C14.9132 25.3508 14.9132 25.7321 15.1493 25.9682L17.2193 28.0321C17.4554 28.2742 17.8367 28.2742 18.0728 28.0321L19.7191 26.3918C20.0278 26.5431 20.3426 26.6763 20.6694 26.7853V29.1095C20.6694 29.4424 20.9418 29.7148 21.2747 29.7148H24.1982C24.531 29.7148 24.8034 29.4424 24.8034 29.1095V26.7853C25.1303 26.6763 25.445 26.5431 25.7537 26.3918L27.4 28.0382C27.509 28.1471 27.6664 28.2137 27.8237 28.2137C27.9871 28.2137 28.1385 28.1471 28.2535 28.0382L30.3175 25.9682C30.5596 25.7321 30.5596 25.3508 30.3175 25.1147L28.6772 23.4684C28.8285 23.1597 28.9617 22.8449 29.0706 22.5181H31.3948C31.7278 22.5181 32.0001 22.2457 32.0001 21.9128V18.9893C32.0001 18.6564 31.7278 18.384 31.3948 18.384ZM22.7334 24.3097C20.6088 24.3097 18.8778 22.5786 18.8778 20.448C18.8778 18.3235 20.6088 16.5925 22.7334 16.5925C24.8639 16.5925 26.595 18.3235 26.595 20.448C26.595 22.5786 24.8639 24.3097 22.7334 24.3097Z"
                fill="#265D91"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_373_934"
                x="0"
                y="0.661499"
                width="36"
                height="37.0533"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_373_934"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_373_934"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>

          Dossier de Compétences
        </h1>

        <!--begin::Menu-->
        <div
          class="menu menu-sub menu-sub-dropdown menu-column style-menu menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4"
          data-kt-menu="true"
        >
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#kt_customers_export_modal"
              class="menu-link px-3"
              >Ajout unitaire</a
            >
          </div>
          <!--end::Menu item-->
          <!--begin::Menu item-->
          <div class="menu-item px-3">
            <a
              href="#"
              class="menu-link px-3"
              data-kt-customer-table-filter="delete_row"
              >Ajout en masse</a
            >
          </div>
          <!--end::Menu item-->
        </div>
      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul
        class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
      >
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/" class="text-muted">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Changer mot de passe</li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div class="d-flex flex-column flex-root" id="kt_app_root">
  <!--begin::Authentication - change password-->
  <div class="flex-column-fluid" [formGroup]="changePasswordForm">
    <!--begin::Content-->
    <div class="p-10">
      <!--begin::Wrapper-->
      <div class="card py-5">
        <div class="content py-1 py-lg-10">
          <!--begin::Logo-->
          <div class="title mb-15">
            <h4>
              <svg
                width="29"
                height="30"
                viewBox="0 0 29 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_395_2417)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.4959 0C12.6752 0 11.196 1.47123 11.196 3.28456V5.01955H10.8082C10.0334 5.01955 9.3953 5.65234 9.3953 6.42418V11.6328C9.3953 12.4047 10.0334 13.0367 10.8082 13.0367H18.1829C18.9577 13.0367 19.5928 12.4047 19.5928 11.6328V6.42418C19.5928 5.65234 18.9577 5.01955 18.1829 5.01955H17.7922V3.28456C17.7922 1.47123 16.3166 0 14.4959 0ZM14.4959 0.753449C15.9108 0.753449 17.0359 1.87577 17.0359 3.28456V5.01955H11.9523V3.28456C11.9523 1.87577 13.081 0.753449 14.4959 0.753449ZM14.4959 8.03408C14.5957 8.03447 14.6913 8.07413 14.7618 8.14442C14.8324 8.21471 14.8722 8.30993 14.8726 8.40933V9.64693C14.8722 9.74634 14.8324 9.84156 14.7618 9.91185C14.6913 9.98214 14.5957 10.0218 14.4959 10.0222C14.4463 10.0224 14.397 10.0128 14.3511 9.99407C14.3051 9.97532 14.2633 9.94773 14.2281 9.91289C14.1928 9.87804 14.1648 9.83662 14.1456 9.79099C14.1265 9.74536 14.1165 9.69641 14.1163 9.64693V8.40933C14.1165 8.35986 14.1265 8.31091 14.1456 8.26528C14.1648 8.21965 14.1928 8.17823 14.2281 8.14338C14.2633 8.10854 14.3051 8.08095 14.3511 8.0622C14.397 8.04344 14.4463 8.03389 14.4959 8.03408ZM5.22825 13.8321C4.55393 13.8321 4 14.3839 4 15.0557V20.6264C4 21.2982 4.55393 21.85 5.22825 21.85H23.7606C24.4349 21.85 24.9918 21.2982 24.9918 20.6264V15.0557C24.9918 14.3839 24.4349 13.8321 23.7606 13.8321H5.22825ZM8.13972 15.2926C8.18963 15.2924 8.23908 15.3021 8.28523 15.321C8.33138 15.34 8.37331 15.3678 8.4086 15.403C8.44389 15.4381 8.47184 15.4799 8.49085 15.5259C8.50986 15.5719 8.51955 15.6211 8.51935 15.6708V16.9209L9.38422 16.0431C9.45398 15.9717 9.54932 15.9307 9.64937 15.9291C9.7496 15.9283 9.84603 15.9672 9.91747 16.0373C9.98871 16.1071 10.0293 16.2021 10.0304 16.3017C10.0315 16.4012 9.99305 16.4971 9.92338 16.5685L9.04078 17.4639H10.2808C10.3808 17.4643 10.4764 17.5041 10.547 17.5745C10.6176 17.645 10.6573 17.7404 10.6575 17.8399C10.6577 17.8894 10.6481 17.9384 10.6293 17.9842C10.6105 18.03 10.5828 18.0716 10.5478 18.1068C10.5128 18.1419 10.4713 18.1698 10.4254 18.1889C10.3796 18.208 10.3305 18.2179 10.2808 18.2181H9.04077L9.92337 19.1136C9.99304 19.1849 10.0315 19.2809 10.0304 19.3804C10.0293 19.48 9.98871 19.575 9.91747 19.6448C9.84585 19.7142 9.74955 19.7526 9.64964 19.7515C9.54972 19.7504 9.45429 19.71 9.38422 19.639L8.51935 18.7612V20.0113C8.51955 20.061 8.50986 20.1103 8.49085 20.1562C8.47184 20.2022 8.44389 20.244 8.4086 20.2791C8.3733 20.3143 8.33138 20.3421 8.28523 20.3611C8.23908 20.38 8.18963 20.3897 8.13972 20.3895C8.09 20.3894 8.04079 20.3795 7.9949 20.3604C7.94901 20.3414 7.90734 20.3135 7.87228 20.2783C7.83723 20.2432 7.80947 20.2015 7.7906 20.1557C7.77173 20.1099 7.76211 20.0608 7.76231 20.0113V18.7612L6.89744 19.639C6.82736 19.7099 6.73194 19.7504 6.63202 19.7515C6.5321 19.7526 6.43581 19.7142 6.36419 19.6448C6.29295 19.575 6.25234 19.4799 6.25123 19.3804C6.25013 19.2808 6.28861 19.1849 6.35828 19.1136L7.24089 18.2181H6.00155C5.95165 18.2183 5.90219 18.2087 5.85605 18.1897C5.8099 18.1708 5.76797 18.143 5.73268 18.1078C5.69739 18.0726 5.66944 18.0309 5.65043 17.9849C5.63142 17.9389 5.62173 17.8897 5.62193 17.8399C5.62203 17.7904 5.63193 17.7414 5.65107 17.6957C5.67021 17.6499 5.69821 17.6084 5.73347 17.5735C5.76873 17.5386 5.81056 17.5109 5.85656 17.4921C5.90256 17.4733 5.95183 17.4638 6.00155 17.464H7.24089L6.35829 16.5685C6.28862 16.4971 6.25013 16.4012 6.25124 16.3017C6.25234 16.2021 6.29295 16.1071 6.36419 16.0373C6.43581 15.9679 6.53211 15.9295 6.63202 15.9306C6.73194 15.9317 6.82736 15.9721 6.89744 16.0431L7.76231 16.9209V15.6708C7.76212 15.6213 7.77173 15.5722 7.7906 15.5264C7.80947 15.4806 7.83723 15.4389 7.87228 15.4038C7.90734 15.3686 7.94901 15.3407 7.9949 15.3217C8.04079 15.3026 8.09 15.2927 8.13972 15.2926ZM14.4959 15.2926C14.5456 15.2928 14.5947 15.3028 14.6405 15.3219C14.6863 15.341 14.7279 15.3689 14.7629 15.404C14.7979 15.4391 14.8255 15.4808 14.8444 15.5266C14.8632 15.5723 14.8728 15.6214 14.8726 15.6708V16.9217L15.7382 16.0431C15.8078 15.9719 15.9028 15.9309 16.0026 15.9291C16.0526 15.9284 16.103 15.9376 16.1494 15.9562C16.1958 15.9748 16.238 16.0023 16.2737 16.0373C16.3445 16.1074 16.3846 16.2027 16.3852 16.3022C16.3858 16.4018 16.3468 16.4975 16.2767 16.5685L15.3941 17.4639H16.6342C16.6839 17.4638 16.7332 17.4733 16.7792 17.4921C16.8252 17.5109 16.867 17.5386 16.9023 17.5735C16.9375 17.6084 16.9655 17.6499 16.9847 17.6957C17.0038 17.7414 17.0137 17.7904 17.0138 17.8399C17.014 17.8897 17.0043 17.9389 16.9853 17.9849C16.9663 18.0309 16.9384 18.0726 16.9031 18.1078C16.8678 18.143 16.8258 18.1708 16.7797 18.1897C16.7335 18.2087 16.6841 18.2183 16.6342 18.2181H15.3941L16.2767 19.1136C16.3468 19.1846 16.3858 19.2803 16.3852 19.3798C16.3846 19.4794 16.3445 19.5746 16.2737 19.6448C16.2382 19.6795 16.1961 19.7069 16.15 19.7254C16.1038 19.7439 16.0545 19.7531 16.0047 19.7526C15.955 19.7521 15.9058 19.7417 15.8601 19.7222C15.8144 19.7028 15.773 19.6745 15.7382 19.639L14.8726 18.7604V20.0113C14.8728 20.0607 14.8632 20.1098 14.8444 20.1556C14.8256 20.2013 14.7979 20.243 14.7629 20.2781C14.7279 20.3132 14.6863 20.3411 14.6405 20.3602C14.5947 20.3793 14.5456 20.3893 14.4959 20.3895C14.446 20.3897 14.3966 20.38 14.3504 20.3611C14.3043 20.3421 14.2623 20.3143 14.2271 20.2791C14.1918 20.244 14.1638 20.2022 14.1448 20.1562C14.1258 20.1103 14.1161 20.061 14.1163 20.0113V18.7604L13.2507 19.639C13.1806 19.7099 13.0852 19.7504 12.9853 19.7515C12.8854 19.7526 12.7891 19.7142 12.7174 19.6448C12.6463 19.5749 12.6058 19.4798 12.6049 19.3802C12.6039 19.2807 12.6425 19.1848 12.7123 19.1136L13.5949 18.2181H12.3548C12.3051 18.218 12.2558 18.2082 12.21 18.1891C12.1641 18.17 12.1224 18.1421 12.0873 18.107C12.0523 18.0719 12.0245 18.0302 12.0057 17.9844C11.9868 17.9386 11.9772 17.8895 11.9774 17.8399C11.9776 17.7403 12.0174 17.6448 12.0881 17.5743C12.1589 17.5038 12.2547 17.4642 12.3548 17.464H13.5949L12.7123 16.5685C12.6425 16.4972 12.6039 16.4014 12.6048 16.3018C12.6058 16.2023 12.6463 16.1072 12.7174 16.0373C12.7891 15.9679 12.8853 15.9295 12.9853 15.9306C13.0852 15.9317 13.1806 15.9721 13.2507 16.0431L14.1163 16.9216V15.6708C14.1161 15.6211 14.1258 15.5718 14.1448 15.5258C14.1638 15.4799 14.1918 15.4381 14.227 15.4029C14.2623 15.3678 14.3043 15.3399 14.3504 15.321C14.3966 15.3021 14.446 15.2924 14.4959 15.2926ZM20.8491 15.2926C20.8988 15.2928 20.9479 15.3028 20.9937 15.3219C21.0396 15.341 21.0811 15.3689 21.1161 15.404C21.1511 15.4391 21.1788 15.4808 21.1976 15.5266C21.2164 15.5723 21.226 15.6214 21.2258 15.6708V16.9217L22.0914 16.0431C22.1263 16.0074 22.168 15.9789 22.214 15.9594C22.26 15.9398 22.3095 15.9295 22.3595 15.9291C22.4595 15.9285 22.5556 15.9674 22.6269 16.0373C22.6981 16.1071 22.7387 16.2021 22.7398 16.3017C22.7409 16.4012 22.7024 16.4971 22.6328 16.5685L21.7502 17.4639H22.9873C23.037 17.4638 23.0863 17.4733 23.1323 17.4921C23.1783 17.5109 23.2201 17.5386 23.2554 17.5735C23.2906 17.6084 23.3186 17.6499 23.3378 17.6957C23.3569 17.7414 23.3668 17.7904 23.3669 17.8399C23.3671 17.8897 23.3574 17.9389 23.3384 17.9849C23.3194 18.0309 23.2914 18.0726 23.2562 18.1078C23.2209 18.143 23.1789 18.1708 23.1328 18.1897C23.0866 18.2087 23.0372 18.2183 22.9873 18.2181H21.7502L22.6328 19.1136C22.7024 19.1849 22.7409 19.2809 22.7398 19.3804C22.7387 19.48 22.6981 19.575 22.6269 19.6448C22.5914 19.6795 22.5494 19.7069 22.5032 19.7254C22.4571 19.7439 22.4077 19.7531 22.3579 19.7526C22.3082 19.7521 22.2591 19.7417 22.2133 19.7222C22.1676 19.7028 22.1262 19.6745 22.0914 19.639L21.2258 18.7605V20.0113C21.226 20.0608 21.2164 20.1098 21.1976 20.1556C21.1788 20.2014 21.1511 20.243 21.1161 20.2781C21.0811 20.3132 21.0395 20.3411 20.9937 20.3603C20.9479 20.3794 20.8988 20.3893 20.8491 20.3895C20.7992 20.3897 20.7498 20.38 20.7036 20.3611C20.6575 20.3422 20.6156 20.3143 20.5803 20.2792C20.545 20.244 20.517 20.2022 20.498 20.1563C20.479 20.1103 20.4693 20.061 20.4695 20.0113V18.7634L19.6069 19.639C19.5721 19.6746 19.5306 19.703 19.4848 19.7225C19.439 19.7421 19.3898 19.7524 19.34 19.753C19.2901 19.7535 19.2407 19.7442 19.1945 19.7257C19.1483 19.7071 19.1062 19.6796 19.0707 19.6448C18.9995 19.5749 18.959 19.4798 18.9581 19.3803C18.9571 19.2807 18.9957 19.1848 19.0655 19.1136L19.9481 18.2181H18.708C18.6584 18.2179 18.6092 18.208 18.5634 18.1889C18.5176 18.1698 18.4761 18.1419 18.4411 18.1068C18.4061 18.0716 18.3784 18.03 18.3596 17.9842C18.3408 17.9384 18.3312 17.8894 18.3314 17.8399C18.3316 17.7404 18.3713 17.645 18.4419 17.5745C18.5124 17.5041 18.6081 17.4643 18.708 17.4639H19.9481L19.0655 16.5685C18.9957 16.4972 18.9571 16.4014 18.9581 16.3018C18.959 16.2023 18.9995 16.1072 19.0707 16.0373C19.1062 16.0024 19.1483 15.975 19.1945 15.9564C19.2407 15.9378 19.2901 15.9286 19.34 15.9291C19.3898 15.9297 19.439 15.94 19.4848 15.9596C19.5306 15.9791 19.5721 16.0075 19.6069 16.0431L20.4695 16.9187V15.6708C20.4693 15.6211 20.479 15.5718 20.498 15.5258C20.517 15.4799 20.545 15.4381 20.5803 15.4029C20.6156 15.3678 20.6575 15.3399 20.7036 15.321C20.7498 15.302 20.7992 15.2924 20.8491 15.2926Z"
                    fill="#265D91"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_395_2417"
                    x="0"
                    y="0"
                    width="28.9918"
                    height="29.85"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_395_2417"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_395_2417"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              Changer mot de passe
            </h4>
          </div>
          <!--end::Logo-->
          <!--begin::Title-->

          <!--end::Text-->
          <!--begin::Illustration-->
          <div class="forms mb-3">
            <div class="fv-row mb-8">
              <!--begin::Password-->
              <label for="password">Mot de passe actuel</label>
              <div class="input-group input-login mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <svg
                    width="11"
                    height="17"
                    viewBox="0 0 11 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4409 6.57137H9.70869V4.06701C9.70869 1.8243 7.82059 0 5.50019 0C3.17978 0 1.29168 1.82466 1.29168 4.06701V6.57137H0.559493C0.250653 6.57137 0 6.81319 0 7.11195V15.3101C0 16.2421 0.784781 17 1.74897 17H9.25102C10.2156 17 11 16.2417 11 15.3101V7.11195C11.0004 6.81355 10.7497 6.57137 10.4409 6.57137ZM2.41067 4.06701C2.41067 2.42075 3.79672 1.08117 5.50019 1.08117C7.20365 1.08117 8.5897 2.42075 8.5897 4.06701V6.57137H2.41067V4.06701ZM9.88138 15.3101C9.88138 15.646 9.59865 15.9188 9.2514 15.9188H1.74897C1.40134 15.9188 1.11899 15.6457 1.11899 15.3101V7.65254H1.80791C1.82245 7.65362 1.83625 7.65687 1.85117 7.65687C1.86609 7.65687 1.87989 7.65362 1.89444 7.65254H9.10593C9.12048 7.65362 9.13428 7.65687 9.1492 7.65687C9.16412 7.65687 9.17792 7.65362 9.19246 7.65254H9.88138V15.3101ZM5.50019 9.68334C4.83178 9.68334 4.28795 10.2088 4.28795 10.8546C4.28795 11.3044 4.55464 11.6911 4.94069 11.8875V13.3179C4.94069 13.6167 5.19135 13.8585 5.50019 13.8585C5.80903 13.8585 6.05968 13.6167 6.05968 13.3179V11.8875C6.44573 11.6914 6.71242 11.3044 6.71242 10.8546C6.71242 10.2088 6.16859 9.68334 5.50019 9.68334Z"
                      fill="#7E7C7C"
                    />
                  </svg>
                </span>
                <input
                  id="oldPassword"
                  formControlName="oldPassword"
                  [type]="showPassword"
                  class="form-control"
                  aria-label="tel"
                  aria-describedby="basic-addon1"
                />
                <i
                  *ngIf="showPassword == 'password'"
                  (click)="showPassword = 'text'"
                  class="fa-regular fa-eye-slash"
                ></i>
                <i
                  *ngIf="showPassword == 'text'"
                  (click)="showPassword = 'password'"
                  class="fa-regular fa-eye"
                ></i>
              </div>
              <app-feild-error
                [controlName]="'password'"
                [control]="changePasswordForm.get('oldPassword')"
              ></app-feild-error>
              <!--end::Password-->
            </div>
          </div>
          <div class="forms mb-3">
            <div class="fv-row mb-8">
              <!--begin::Password-->
              <label for="password">Nouveau Mot de passe</label>
              <div class="input-group input-login mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <svg
                    width="11"
                    height="17"
                    viewBox="0 0 11 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4409 6.57137H9.70869V4.06701C9.70869 1.8243 7.82059 0 5.50019 0C3.17978 0 1.29168 1.82466 1.29168 4.06701V6.57137H0.559493C0.250653 6.57137 0 6.81319 0 7.11195V15.3101C0 16.2421 0.784781 17 1.74897 17H9.25102C10.2156 17 11 16.2417 11 15.3101V7.11195C11.0004 6.81355 10.7497 6.57137 10.4409 6.57137ZM2.41067 4.06701C2.41067 2.42075 3.79672 1.08117 5.50019 1.08117C7.20365 1.08117 8.5897 2.42075 8.5897 4.06701V6.57137H2.41067V4.06701ZM9.88138 15.3101C9.88138 15.646 9.59865 15.9188 9.2514 15.9188H1.74897C1.40134 15.9188 1.11899 15.6457 1.11899 15.3101V7.65254H1.80791C1.82245 7.65362 1.83625 7.65687 1.85117 7.65687C1.86609 7.65687 1.87989 7.65362 1.89444 7.65254H9.10593C9.12048 7.65362 9.13428 7.65687 9.1492 7.65687C9.16412 7.65687 9.17792 7.65362 9.19246 7.65254H9.88138V15.3101ZM5.50019 9.68334C4.83178 9.68334 4.28795 10.2088 4.28795 10.8546C4.28795 11.3044 4.55464 11.6911 4.94069 11.8875V13.3179C4.94069 13.6167 5.19135 13.8585 5.50019 13.8585C5.80903 13.8585 6.05968 13.6167 6.05968 13.3179V11.8875C6.44573 11.6914 6.71242 11.3044 6.71242 10.8546C6.71242 10.2088 6.16859 9.68334 5.50019 9.68334Z"
                      fill="#7E7C7C"
                    />
                  </svg>
                </span>
                <input
                  id="newPassword"
                  formControlName="newPassword"
                  [type]="showNewPassword"
                  class="form-control"
                  aria-label="tel"
                  aria-describedby="basic-addon1"
                />
                <i
                  *ngIf="showNewPassword == 'password'"
                  (click)="showNewPassword = 'text'"
                  class="fa-regular fa-eye-slash"
                ></i>
                <i
                  *ngIf="showNewPassword == 'text'"
                  (click)="showNewPassword = 'password'"
                  class="fa-regular fa-eye"
                ></i>
              </div>
              <app-feild-error
                [controlName]="'password'"
                [control]="changePasswordForm.get('newPassword')"
              ></app-feild-error>
              <!--end::Password-->
            </div>
          </div>
          <div class="forms mb-3">
            <div class="fv-row mb-8">
              <!--begin::Password-->
              <label for="password">Confirmer Mot de passe</label>
              <div class="input-group input-login mb-5">
                <span class="input-group-text" id="basic-addon1">
                  <svg
                    width="11"
                    height="17"
                    viewBox="0 0 11 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.4409 6.57137H9.70869V4.06701C9.70869 1.8243 7.82059 0 5.50019 0C3.17978 0 1.29168 1.82466 1.29168 4.06701V6.57137H0.559493C0.250653 6.57137 0 6.81319 0 7.11195V15.3101C0 16.2421 0.784781 17 1.74897 17H9.25102C10.2156 17 11 16.2417 11 15.3101V7.11195C11.0004 6.81355 10.7497 6.57137 10.4409 6.57137ZM2.41067 4.06701C2.41067 2.42075 3.79672 1.08117 5.50019 1.08117C7.20365 1.08117 8.5897 2.42075 8.5897 4.06701V6.57137H2.41067V4.06701ZM9.88138 15.3101C9.88138 15.646 9.59865 15.9188 9.2514 15.9188H1.74897C1.40134 15.9188 1.11899 15.6457 1.11899 15.3101V7.65254H1.80791C1.82245 7.65362 1.83625 7.65687 1.85117 7.65687C1.86609 7.65687 1.87989 7.65362 1.89444 7.65254H9.10593C9.12048 7.65362 9.13428 7.65687 9.1492 7.65687C9.16412 7.65687 9.17792 7.65362 9.19246 7.65254H9.88138V15.3101ZM5.50019 9.68334C4.83178 9.68334 4.28795 10.2088 4.28795 10.8546C4.28795 11.3044 4.55464 11.6911 4.94069 11.8875V13.3179C4.94069 13.6167 5.19135 13.8585 5.50019 13.8585C5.80903 13.8585 6.05968 13.6167 6.05968 13.3179V11.8875C6.44573 11.6914 6.71242 11.3044 6.71242 10.8546C6.71242 10.2088 6.16859 9.68334 5.50019 9.68334Z"
                      fill="#7E7C7C"
                    />
                  </svg>
                </span>
                <input
                  id="confirmNewPassword"
                  formControlName="confirmNewPassword"
                  [type]="showConfirmPassword"
                  class="form-control"
                  aria-label="tel"
                  aria-describedby="basic-addon1"
                />
                <i
                  *ngIf="showConfirmPassword == 'password'"
                  (click)="showConfirmPassword = 'text'"
                  class="fa-regular fa-eye-slash"
                ></i>
                <i
                  *ngIf="showConfirmPassword == 'text'"
                  (click)="showConfirmPassword = 'password'"
                  class="fa-regular fa-eye"
                ></i>
              </div>
              <span
                style="color: red"
                *ngIf="
                  changePasswordForm.get('confirmNewPassword') &&
                  changePasswordForm.get('confirmNewPassword')?.errors &&
                  changePasswordForm.get('confirmNewPassword')?.value != ''
                "
              >
                <small>Les mots de passe ne correspondent pas.</small>
              </span>
              <app-feild-error
                *ngIf="
                  !changePasswordForm.get('confirmNewPassword') &&
                  !changePasswordForm.get('confirmNewPassword')?.errors
                "
                [controlName]="'password'"
                [control]="changePasswordForm.get('confirmNewPassword')"
              ></app-feild-error>
              <!--end::Password-->
            </div>
          </div>

          <!-- <div
            class="d-flex justify-content-center"
            *ngIf="
              changePasswordForm.get('confirmNewPassword') &&
              changePasswordForm.get('confirmNewPassword')?.errors &&
              changePasswordForm.get('confirmNewPassword')?.value != ''
            "
          >
            <label style="color: red">
              <small>Les mots de passe ne correspondent pas.</small>
            </label>
          </div> -->
        </div>
        <!--end::Illustration-->
        <!--begin::Submit-->
        <div class="d-flex justify-content-end footbtn">
          <button
            *ngIf="!loadSpinner"
            [disabled]="!this.changePasswordForm.valid"
            type="button"
            id="kt_sing_in_two_factor_submit"
            class="confirm pt-5 pb-5"
            (click)="changePassword()"
          >
            <span class="indicator-label">Confirmer</span>
          </button>
          <div
            *ngIf="loadSpinner"
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <!--end::Submit -->
      </div>
    </div>
    <!--end::Wrapper-->
  </div>
  <!--end::Content-->
  <!--end::Authentication - change password-->
</div>
